<template>
    <div id="orthoTreatmentDiv" class="ortho-treatment-item">

        <div id="orthoTreatmentOriginalDiv" class="ortho-treatment-item toggle-div"
            v-on:click.stop="switchShowOriginalClick($event)">
            <input id="orthoTreatmentOriginalButton" type="checkbox" class="toggle-ortho-treatment-button" />
            <div id="orthoTreatmentOriginalLabel" class="toggle-title">SHOW ORIGINAL</div>
        </div>

        <div id="orthoTreatmentCollisionsDiv" class="ortho-treatment-item toggle-div"
            v-on:click.stop="switchShowCollisionsClick($event)">
            <input id="orthoTreatmentCollisionsButton" type="checkbox" class="toggle-ortho-treatment-button" />
            <div id="orthoTreatmentCollisionsLabel" class="toggle-title">SHOW ROOT COLLISIONS</div>
        </div>

        <div id="orthoTreatmentClosedBonesDiv" class="ortho-treatment-item toggle-div"
            v-on:click.stop="switchClosedBonesClick($event)">
            <input id="orthoTreatmentClosedBonesButton" type="checkbox" class="toggle-ortho-treatment-button" />
            <div id="orthoTreatmentClosedBonesLabel" class="toggle-title">SHOW CLOSED BONES</div>
        </div>

        <div id="orthoTreatmentAnchorageLossDiv" class="ortho-treatment-item toggle-div"
            v-on:click.stop="showAnchorageLossClick($event)">
            <input id="orthoTreatmentAnchorageLossButton" type="checkbox" class="toggle-ortho-treatment-button" />
            <div id="orthoTreatmentAnchorageLossLabel" class="toggle-title">SHOW ANCHORAGE LOSS</div>
        </div>

    </div>
</template>

<script>

import {
    OrthoPlanMode,
    switchTreatmentShowOriginal,
    switchTreatmentClosedBones
    , toggleAnchorageLoss

} from "./OrthoPlanMode.js";

import {
    switchTreatmentShowCollisions
} from "./OrthoTreatment.js";

export default {
    name: "OrthoTreatmentControls",
    props: ["isIntraoral", "treatmentContext"],
    methods: {
        switchShowOriginalClick: function () {
            switchTreatmentShowOriginal();
        },
        switchShowCollisionsClick: function () {
            switchTreatmentShowCollisions(!this.treatmentContext.showRootCollisions);
        },
        switchClosedBonesClick: function () {
            switchTreatmentClosedBones();
        },
        showAnchorageLossClick: function () {
            toggleAnchorageLoss(!OrthoPlanMode.showAnchorageLoss);
        },
    },
    mounted: function () {
        // setTimeout(function () {
        canecode_switch(".toggle-ortho-treatment-button");
        switchToggle('orthoTreatmentClosedBonesDiv', this.treatmentContext.showAllStages);
        switchToggle('orthoTreatmentOriginalDiv', this.treatmentContext.showOriginal);
        switchToggle('orthoTreatmentCollisionsDiv', this.treatmentContext.showRootCollisions);
        switchToggle('orthoTreatmentAnchorageLossDiv', false);

        if (!vueApp.hasClosedBones) {
            document.getElementById("orthoTreatmentAnchorageLossDiv").style.display = "none";
            document.getElementById("orthoTreatmentClosedBonesDiv").style.display = "none"
        }
        // }, 999);
    }
};
</script>

<style scoped>
.ortho-treatment-item {
    position: absolute;
}

#orthoTreatmentDiv {
    left: calc(50% - 220px);
    top: 50px;
    width: 440px;
    color: white;
    display: none;
}

#orthoTreatmentOriginalDiv {
    left: calc(50% - 245px);
    /* top: 75px; */
}

#orthoTreatmentOriginalLabel {
    margin-left: -20px;
}

#orthoTreatmentCollisionsDiv {
    left: calc(50% - 85px);
}

#orthoTreatmentCollisionsLabel {
    margin-left: -45px;
}

#orthoTreatmentClosedBonesDiv {
    left: calc(50% + 90px);
}

#orthoTreatmentClosedBonesLabel {
    margin-left: -35px;
}

#orthoTreatmentAnchorageLossDiv {
    width: 120px;
    left: calc(50% - 85px);
    top: 150px;
    display: none;
}

#orthoTreatmentAnchorageLossLabel {
    margin-left: -50px;
}
</style>